var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn fs-3 px-2 py-0 lh-1 text-primary",attrs:{"title":_vm.tooltipTitle,"data-bs-toggle":"modal","data-bs-target":_vm.modal},on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{class:_vm.icon})])
}
var staticRenderFns = []

export { render, staticRenderFns }